<template>
  <el-select size="mini" v-model="singleDefault" :popper-append-to-body="true" :placeholder="placeholder" popper-class='multi-option' @change="change" @focus="focus" @blur="blur">
    <el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.value"></el-option>
  </el-select>
</template>

<script>
import Clickoutside from '@/utils/clickoutside'
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import last from "lodash/last";

export default {
  props: ["value", "options", "placeholder", "constraint"],
  data() {
    return {
      singleDefault: true
    };
  },
  directives: { Clickoutside },

  watch: {
    value: {
      immediate: true,
      handler(newVal, oldVal) {
        this.singleDefault = !isNil(newVal) ? newVal : true;
      }
    }
  },

  mounted() {
    this.$emit('change', this.singleDefault);
  },

  methods: {
    focus() {
      this.$emit('input-cv-focus', true);
    },
    blur() {
      this.$emit('input-cv-focus', false);
    },

    validator() {
      return isNil(this.singleDefault) ? '请填选必填项' : '';
    },

    change() {
      this.$emit("change", this.singleDefault);
    }
  }
};
</script>

<style lang="scss">
.multi-option {
  margin-top: 4px !important;
}
</style>
